"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMultiChoiceButton = exports.StyledMultipleChoiceContentWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const MultipleChoiceButton_1 = require("./components/MultipleChoiceButton/MultipleChoiceButton");
const constants_1 = require("./helpers/constants");
const styles_1 = require("../../helpers/styles");
const View_1 = require("../../View");
exports.StyledMultipleChoiceContentWrapper = (0, styled_components_1.default)(View_1.View) `
    max-width: ${constants_1.MAX_WIDTH_MENU};
`;
exports.StyledMultiChoiceButton = (0, styled_components_1.default)(MultipleChoiceButton_1.MultipleChoiceButton) `
    ${({ size, isFitControlSize }) => {
    const cssWidth = isFitControlSize ? 'width' : 'max-width';
    return (0, styled_components_1.css) `
            ${cssWidth}: ${typeof size === 'string' ? size : (0, styles_1.calcWidth)(size)};
        `;
}}
`;
//# sourceMappingURL=MultipleChoice.styles.js.map